export const CSS = {
  handle: "handle",
  handleSelected: "handle--selected",
};

export const ICONS = {
  drag: "drag",
};

export const SUBSTITUTIONS = {
  itemLabel: "{itemLabel}",
  position: "{position}",
  total: "{total}",
};
